import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const fetchUnassignedClients = createAsyncThunk('clients/fetchUnassignedClients', async ({ page, account_type = 'unassigned', searchTerm = '', activeCoach = '', user_type ='' }) => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/get-unassigned-clients`, {
    params: {
      page,
      account_type,
      searchTerm,
      active_coach:activeCoach,
      user_type:user_type
    },
  });
  return response.data;
});

const unassignedSlice = createSlice({
  name: 'admin_unassigned_clients',
  initialState: {
    unassigned_users: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    successMessage: '',
    errorMessage: '',
    programs_minimal: []
  },
  reducers: {
    clearMessages: (state) => {
      state.successMessage = '';
      state.errorMessage = '';
      state.programs_minimal = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnassignedClients.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(fetchUnassignedClients.fulfilled, (state, action) => {
        state.unassigned_users = action.payload.data.data;
        state.currentPage = action.payload.data.current_page || 1;
        state.totalPages = action.payload.data.last_page || 0;
        state.loading = false;
      })
      .addCase(fetchUnassignedClients.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message;
      });
  },
});

export const { clearMessages } = unassignedSlice.actions;
export default unassignedSlice.reducer;